import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import facebookImage from "../assets/footer/ic_fb.svg"
import twitterImage from "../assets/footer/ic_twitter.svg"
import linkedinImage from "../assets/footer/ic_linkedin.svg"
import youtubeImage from "../assets/footer/ic_youtube.svg"
import instagramImage from "../assets/footer/ic_insta.svg"
import playstoreImage from "../assets/img/site-patrons/ic_google_pay.png"
import appstoreImage from "../assets/img/site-patrons/ic_app_store.png"
import heartImage from "../assets/footer/ic_made_with_love.svg"

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="site-footer">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-md-3 pb-4">
                    <h4 className="font-proxima-nova-bold text-white mb-3">
                      <FormattedMessage
                        id="WINDS-E-Pvt-Ltd"
                        defaultMessage="WINDS E Pvt Ltd"
                        values={{ what: "react-intl" }}
                      />
                    </h4>
                    <p><FormattedMessage id="WINDS-E-Pvt-Ltd-desc" /></p>

                    <h4 className="font-proxima-nova-bold text-white mb-3 mt-md-5 mt-4">
                      <FormattedMessage
                        id="follow"
                        defaultMessage="Follow Us On"
                      />
                    </h4>
                    <div className="social-links text-center">
                      <Link className="facebook" to={{ pathname: "https://www.facebook.com/windsapp" }} target="_blank">
                        <img src={facebookImage} alt="social-icon" width="20px" />
                      </Link>
                      <Link className="twitter" to={{ pathname: "https://twitter.com/WINDSapp" }} target="_blank">
                        <img src={twitterImage} alt="social-icon" width="20px" />
                      </Link>
                      <Link className="linkedin" to={{ pathname: "https://www.linkedin.com/company/winds-e-pvt-ltd/" }} target="_blank">
                        <img src={linkedinImage} alt="social-icon" width="20px" />
                      </Link>
                      <Link className="youtube" to={{ pathname: "https://www.youtube.com/channel/UC9oRFRK-5QmokZsS-cBMd2Q" }} target="_blank">
                        <img src={youtubeImage} alt="social-icon" width="20px" />
                      </Link>
                      <Link className="instagram" to={{ pathname: "https://www.instagram.com/winds.app" }} target="_blank">
                        <img src={instagramImage} alt="social-icon" width="20px" />
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-2 pb-4">
                    <h4 className="font-proxima-nova-bold text-white mb-3">
                      <FormattedMessage
                        id="footer.quick-link"
                        defaultMessage="Quick Links"
                        description="Quick Links"
                        values={{ what: "react-intl" }}
                      />
                    </h4>
                    <div className="row">
                      <p className="col-12">
                        <Link to="/patrons">
                          <FormattedMessage
                            id="patrons"
                            defaultMessage="Patrons"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/partner">
                          <FormattedMessage
                            id="partner"
                            defaultMessage="Partner"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/digi-world">
                          <FormattedMessage
                            id="winds-digi-world"
                            defaultMessage="WINDS Digi-World"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/about-us">
                          <FormattedMessage
                            id="about-us"
                            defaultMessage="About Us"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/luckydraw-patrons">
                          <FormattedMessage
                            id="luckydraw-patrons"
                            defaultMessage="Luckydraw-Patrons"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/luckydraw-partners">
                          <FormattedMessage
                            id="luckydraw-partners"
                            defaultMessage="Luckydraw-Partners"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/testimonials">
                          <FormattedMessage
                            id="testimonials"
                            defaultMessage="Testimonials"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>

                    </div>
                  </div>
                  <div className="col-md-2 pb-4">
                    <h4 className="font-proxima-nova-bold text-white mb-3">
                      <FormattedMessage
                        id="help"
                        defaultMessage="Help"
                        values={{ what: "react-intl" }}
                      />
                    </h4>
                    <div className="row">
                      <p className="col-12">
                        <Link to="/contact-us">
                          <FormattedMessage
                            id="contact-us"
                            defaultMessage="Contact Us"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/ebrochure">
                          <FormattedMessage
                            id="e-brochure"
                            defaultMessage="E-Brochure"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/terms-condition">
                          <FormattedMessage
                            id="footer.terms-and-conditions"
                            defaultMessage="Terms & Conditions"
                            description="Terms & Conditions"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/privacy-policy">
                          <FormattedMessage
                            id="footer.privacy-policy"
                            defaultMessage="Privacy Policy"
                            description="Privacy Policy"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/credits">
                          <FormattedMessage
                            id="footer.credits"
                            defaultMessage="Credits"
                            description="Credits"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                      <p className="col-12">
                        <Link to="/faq">
                          <FormattedMessage
                            id="footer.faq"
                            defaultMessage="FAQ"
                            description="FAQ"
                            values={{ what: "react-intl" }}
                          />
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div className="col-md-2 pb-4">
                    <h4 className="font-proxima-nova-bold text-white mb-3">
                      <FormattedMessage
                        id="WINDS-Apps"
                        defaultMessage="WINDS Apps"
                        values={{ what: "react-intl" }}
                      />
                    </h4>
                    <div className="row">
                      <p className="col-12">
                        <a href="https://winds.to/app" target="_blank" rel="noreferrer">
                          <FormattedMessage
                            id="patrons"
                            defaultMessage="Patrons"
                            values={{ what: "react-intl" }}
                          />
                        </a>
                      </p>
                      <p className="col-12">
                        <a href="https://p.winds.to/app" target="_blank" rel="noreferrer">
                          <FormattedMessage
                            id="partner"
                            defaultMessage="Partner"
                            values={{ what: "react-intl" }}
                          />
                        </a>
                      </p>
                      <p className="col-12">
                        <a href="https://c.winds.to/app" target="_blank" rel="noreferrer">
                          <FormattedMessage
                            id="captain"
                            defaultMessage="Captain"
                            values={{ what: "react-intl" }}
                          />
                        </a>
                      </p>
                    </div>
                    <h4 className="font-proxima-nova-bold text-white mb-3 mt-4">
                      <FormattedMessage
                        id="download-now"
                        defaultMessage="Download Now"
                        values={{ what: "react-intl" }}
                      />
                    </h4>
                    <div>
                      <a href="https://winds.to/app" target="blank" rel="noreferrer">
                        <img width="120px" src={playstoreImage} alt="icon" />
                      </a>
                      <a href="https://winds.to/app" target="blank" rel="noreferrer">
                        <img className="mt-md-3 mt-0 ml-md-0 ml-2" width="120px" src={appstoreImage} alt="icon" />
                      </a>
                    </div>
                  </div>

                  <div className="col-md-3 pb-4">
                    <h4 className="font-proxima-nova-bold text-white mb-3">
                      <FormattedMessage
                        id="contact-us"
                        defaultMessage="Contact Us"
                        values={{ what: "react-intl" }}
                      />
                    </h4>
                    <p>
                      <b><FormattedMessage id="WINDS-E-Pvt-Ltd" /></b><br />
                      <FormattedMessage id="address" />
                    </p>
                    <h4 className="font-proxima-nova-bold text-white mb-3 mt-5">
                      <FormattedMessage
                        id="support"
                        defaultMessage="Support"
                        values={{ what: "react-intl" }}
                      />
                    </h4>
                    <p>
                      <span>
                        <FormattedMessage
                          id="footer.email"
                          defaultMessage="Email:"
                          description="Email:"
                          values={{ what: "react-intl" }}
                        />
                      </span>
                      <span> support@winds.co.in</span>
                    </p>
                    <p className="mb-0">
                      <span>
                        <FormattedMessage
                          id="footer.toll-free-number"
                          defaultMessage="Toll Free Number:"
                          description="Toll Free Number:"
                          values={{ what: "react-intl" }}
                        />
                      </span>
                      <span> 1800 103 1032</span>
                    </p>
                    <p>
                      <FormattedMessage
                        id="footer.from-9am-to-9pm"
                        defaultMessage="From 9am to 9pm"
                        description="From 9am to 9pm"
                        values={{ what: "react-intl" }}
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="site-footer-heart">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center py-3">
                <img src={heartImage} alt="heart" />
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid container-fluid--sub-footer">
          <div className="row">
            <div className="col-12 text-center py-4">
              <small>
                <FormattedMessage
                  id="footer.copyright"
                  defaultMessage="© 2023 Winds E Pvt Ltd. All rights reserved. Please read Terms & Conditions for further details."
                  description="© 2023 Winds E Pvt Ltd. All rights reserved. Please read Terms & Conditions for further details."
                  values={{ what: "react-intl" }}
                />
              </small>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Footer;
